module.exports = __webpack_public_path__ + "templates/points-redeem.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/points/templates/points-redeem.html
// module id = GaRp
// module chunks = 1